module.exports = __webpack_public_path__ + "static/forecast/weather/daylightrain-23997e6e9944efc1c1037162705bba07.svg";